import { AutoMap } from "@automapper/classes";

export class MeanOfPrevention {
    @AutoMap()
    Name!: string;

    public constructor(init?: Partial<MeanOfPrevention>) {
        Object.assign(this, init);
    }
}